import React, { useCallback, useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { verificarAceiteTermosDeUso } from 'services/login/termo-de-uso/termo-de-uso';

const PrivateRoute = ({ component: Component, ...rest }) => {

    const [termoAceito, setTermoAceito] = useState(false);
    const [loading, setLoading] = useState(true);


    const verificarTermos = useCallback(async () => {
        try {
            const { termoAceito } = await verificarAceiteTermosDeUso();
            setTermoAceito(termoAceito);
        } catch (error) {
            console.log('Erro ao verificar os termos de uso:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        verificarTermos();
    }, [verificarTermos]);

    const handleRedirect = () => {
        localStorage.clear();
        return <Redirect to="/login" />;
    }

    if (loading) {
        return null;
    }

    return (
        <Route
            {...rest}
            render={props =>
                termoAceito ? (
                    <Component {...props} />
                ) : (
                    handleRedirect()
                )
            }
        />
    );
};

export default PrivateRoute;
